// extracted by mini-css-extract-plugin
export var label = "_jc-0";
export var treatmentCard = "_jc-1";